import { takeLatest, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import workerSaga from './workerSaga';

export default function* chatbotWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(ActionConstants.SEND_CHAT_MESSAGE, workerSaga);
  yield takeLatest(ActionConstants.CLEAR_CHAT_HISTORY, workerSaga);
  yield takeLatest(ActionConstants.GET_CHAT_SUGGESTIONS, workerSaga);
  yield takeLatest(ActionConstants.CHAT_TICKET_CONFIRM_SUBMIT, workerSaga);
  yield takeLatest(ActionConstants.CHAT_TICKET_CREATE_DIRECT, workerSaga);
  yield takeLatest(ActionConstants.INIT_CHATBOT, workerSaga);
  yield takeLatest(ActionConstants.CHAT_TICKET_LIST_FETCH, workerSaga);
  yield takeLatest(ActionConstants.LOAD_MORE_CHAT_HISTORY, workerSaga);
}
